import {IsNotEmpty, isNotEmpty, IsOptional} from '@pristine-ts/class-validator';
import { translationBaseKey } from '../../../../../decorators/translation-base-key.decorator';
import { clonePropertyMetadata } from '@pristine-ts/metadata';
import {
  IncomeTaxPersonalChildQuebecInIncomeTaxPersonalOptions,
} from '../../../income-tax/personal/personal/income-tax-personal-child-quebec-in-income-tax-personal.options';
import {ErrorMessageBuilder} from "../../../../../builders/error-message.builder";

@translationBaseKey('income-tax-personal-child-quebec-in-rrsp-options')
export class IncomeTaxPersonalChildQuebecInRrspOptions implements IncomeTaxPersonalChildQuebecInIncomeTaxPersonalOptions {
  @clonePropertyMetadata<IncomeTaxPersonalChildQuebecInIncomeTaxPersonalOptions>(IncomeTaxPersonalChildQuebecInIncomeTaxPersonalOptions, 'careExpensesOthers')
  careExpensesOthers: number;
}